import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const LogoCloud: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const logos = (c.logos || []) as Array<{ image_url?: string; alt?: string }>;

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ textAlign: 'center', marginBottom: 32 }}
        >
          {sfHeadline(c, 'Our Clients & Partners')}
        </InlineEditText>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 40, flexWrap: 'wrap' }}>
          {logos.map((lg, i) => lg.image_url ? (
            <img key={i} src={lg.image_url} alt={lg.alt || ''} style={{ height: 48, filter: 'grayscale(100%)', opacity: 0.5 }} />
          ) : null)}
        </div>
      </div>
    </section>
  );
};
export default LogoCloud;
